import { inject, injectable } from 'inversify';
import OrdersRepository from 'src/features/orders/data/OrdersRepository';
import {
  CreateOrderParams,
  PaymentDataParams,
} from 'src/features/orders/data/service/OrdersService.types';
import { PaymentMethodSlug } from 'src/types/common';
import { AxiosError } from 'axios';
import { UnknownError } from 'src/utils/errors/UnknownError';
import { getOpenPayErrorMessage } from 'src/utils/cards/getOpenPayErrorMessage';

export type OpenPayPaymentDataParams = Required<PaymentDataParams>;

export interface CreateOpenPayOrderUseCaseParams
  extends Omit<CreateOrderParams, 'payment_method'> {}

@injectable()
class CreateOpenPayOrderUseCase {
  @inject(OrdersRepository) private ordersRepository!: OrdersRepository;

  async execute(params: CreateOpenPayOrderUseCaseParams) {
    if (
      params.payment &&
      (!params.payment.device_session_id || !params.payment.cvv2)
    ) {
      throw new Error(
        'Los campos device_session_id y cvv2 son obligatorios para OpenPay.'
      );
    }

    try {
      return await this.ordersRepository.createOrder({
        ...params,
        payment_method: PaymentMethodSlug.OpenPay,
      });
    } catch (error) {
      if (
        error instanceof AxiosError &&
        error.response &&
        error.response.data?.code
      ) {
        const openPayErrorCode = error.response.data.code;
        const errorMsg = getOpenPayErrorMessage(openPayErrorCode);

        throw new Error(errorMsg);
      }

      throw new UnknownError(error);
    }
  }
}

export default CreateOpenPayOrderUseCase;
